<template>
  <footer class="clearfix">
    <p>
      為獲得最佳瀏覽體驗，建議使用Edge、Chrome、Firefox，如使用IE部份網頁可能會有破圖、跑版或功能無法正確顯示及使用。
    </p>
    <p>Copyright © 2021 Hanlin 翰林出版事業股份有限公司</p>
  </footer>
</template>

<script>
export default {
    name: 'FooterComponent',
};
</script>

<style></style>
